import React, { useEffect, useState } from 'react'
import { FiSettings } from 'react-icons/fi'
import { baseUrl } from '../../login/baseUrl';
import axios from 'axios';
import { Pagination } from 'antd';
import PageBar from '../../dashboard/page-bar/PageBar';
import UserReportFilter from './userReportFilter/UserReportFilter';

const UserReport = () => {
    const [data, setData] = useState();
    const [loader, setLoader] = useState(false)
    const [filterActive, setFilterActive] = useState(false);
    const [filterValues, setFilterValues] = useState({});
    const [page, setPage] = useState(0);
    const [count, setCount] = useState(10);
    const [total, setTotal] = useState(0);


    const [initialValue, setInitialValue] = useState({
        user_id: '',
        start_date: '',
        end_date: ''
    })

    const onChangeHandle = (e) => {
        const clone = { ...initialValue }
        const value = e.target.value
        const name = e.target.name
        clone[name] = value
        setInitialValue(clone)
    }

    const getCandidatelistDataFilter = async (val = {}, pg = 0) => {
        setLoader(true);
        setFilterActive(true);
        setFilterValues(val);
        setPage(pg);

        try {
            const res = await axios.get(
                `${baseUrl}/candidate/byuser?user_id=${initialValue.user_id}&page=${pg}&count=${count}&start_date=${initialValue.start_date}&end_date=${initialValue.end_date}`,
                {
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                        Authorization: `Bearer ${window.localStorage.getItem('token')}`
                    }
                }
            );

            setData(res?.data?.data || []);
            setTotal(res?.data?.total || 0);
        } catch (error) {
            console.error('Fetch error:', error);
        }

        setLoader(false);
    };

    const onChangeVal = (pg) => {
        if (filterActive) {
            getCandidatelistDataFilter(filterValues, pg);
        } else {
            getCandidatelistDataFilter({}, pg);
        }
    };

    useEffect(() => {
        getCandidatelistDataFilter({}, 0);
    }, []);

    return (
        <div className="pageWrapper">
            <PageBar title="User" />
            {/* <h3 className="page-title">
          List Candidate <small>Candidate</small>
        </h3> */}

            <div className="pageTableWrapper">
                <div className="pageHeader">
                    <div className="pageTitle">
                        <FiSettings />
                        <h5>User Report List</h5>
                    </div>

                </div>
                <UserReportFilter initialValue={initialValue} onChangeHandle={onChangeHandle} getCandidatelistDataFilter={getCandidatelistDataFilter} />
            </div>

            <div className="pageTableWrapper">
                <div className="pageBody">
                    <table className="table table-striped table-bordered">
                        <thead>
                            <tr role="row" className="heading">
                                <th>S.no</th>
                                {/* <th>Date</th> */}
                                <th className="candidate_name_heading">Name</th>
                                <th>Category name</th>
                                <th>Mobile</th>
                                <th>Email</th>
                                <th>Created By</th>
                                {/* <th>Actions</th> */}
                            </tr>
                        </thead>

                        <tbody>
                            {data && data?.map((item, i) => (
                                <tr role="row" className="odd" key={item._id}>
                                    <td><span>{i + 1}</span></td>
                                    {/* <td><span>{new Intl.DateTimeFormat('en-US', options).format(new Date(item.created_at))}</span></td> */}
                                    <td><span className="text-capitalize">{item.name} {item.firstname} {item.lastname}</span></td>
                                    <td>{item.job_category?.category_name}</td>
                                    <td>{item.mobile}</td>
                                    <td>{item.email}</td>
                                    <td>{item.createdBy?.firstname} {item.createdBy?.lastname}</td>
                                    {/* <td>
                                        <div className="dropdown">
                                            <button className="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                Action
                                            </button>
                                            <ul className="dropdown-menu">
                                               
                                                <li>
                                                    <Link className="dropdown-item" to={`edit/${item._id}`}>
                                                        Edit
                                                    </Link>
                                                </li>
                                               
                                            </ul>
                                        </div>
                                    </td> */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>


            <div className="pageFooter">
                <div className="row">
                    <div className="col-md-6">
                        <div className="showEntry">
                            <p>
                                Showing {data?.length} of {total} entries
                            </p>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="text-center">
                            <Pagination
                                current={page}
                                pageSize={count}
                                onChange={onChangeVal}
                                total={total}
                                showSizeChanger={false}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default UserReport